import { User, TripCollection } from "../user/user";

export abstract class DataStream {
	abstract getUser( userId: string ): Promise< User >;
	abstract saveUser( user: User ): Promise< void >;
	abstract getTripCollection( userId: string ): Promise< TripCollection >;
}
